import FR from "./fields.config.FR";

export default FR;
